function initAddonSplides() {
  document.querySelectorAll('.kickback-addon-splide:not([data-addon-initialized])').forEach(function (el) {
    el.setAttribute('data-addon-initialized', 'true');
    new window.Splide(el, {
      type: 'slide',
      perPage: 2,
      perMove: 1,
      gap: '12px',
      pagination: false,
      arrows: true,
      breakpoints: {
        640: { perPage: 1 },
      },
    }).mount();
  });
}

function waitForSplideAndInit() {
  if (typeof window.Splide !== 'undefined') {
    initAddonSplides();
    initAddonEvents();
  } else {
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (typeof window.Splide !== 'undefined') {
        clearInterval(interval);
        initAddonSplides();
        initAddonEvents();
      } else if (attempts > 50) {
        clearInterval(interval);
        console.warn('[kickback-addon] Splide not found after 5s');
      }
    }, 100);
  }
}

function getSelectedVariantId(productId, allVariantsJson) {
  var variants;
  try {
    variants = JSON.parse(allVariantsJson);
  } catch (e) {
    return null;
  }

  var selects = document.querySelectorAll('[data-addon-select="' + productId + '"]');
  if (!selects.length) {
    return variants[0] ? variants[0].id : null;
  }

  var selectedOptions = [];
  selects.forEach(function (sel) {
    selectedOptions.push(sel.value);
  });

  var matched = variants.find(function (v) {
    return v.options.every(function (opt, i) {
      return opt === selectedOptions[i];
    });
  });

  return matched ? matched.id : null;
}

function updatePriceDisplay(productId, allVariantsJson) {
  var variants;
  try {
    variants = JSON.parse(allVariantsJson);
  } catch (e) {
    return;
  }

  var selects = document.querySelectorAll('[data-addon-select="' + productId + '"]');
  var selectedOptions = [];
  selects.forEach(function (sel) {
    selectedOptions.push(sel.value);
  });

  var matched = variants.find(function (v) {
    return v.options.every(function (opt, i) {
      return opt === selectedOptions[i];
    });
  });

  if (!matched) return;

  var priceEl = document.querySelector('[data-addon-price="' + productId + '"]');
  if (!priceEl) return;

  var formatted = (matched.price / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: window.Shopify ? window.Shopify.currency.active : 'USD',
    minimumFractionDigits: 2,
  });
  priceEl.textContent = formatted;

  var btn = document.querySelector('[data-addon-atc][data-product-id="' + productId + '"]');
  if (btn) {
    btn.setAttribute('data-variant-id', matched.id);
  }
}

function addToCart(variantId, button) {
  button.disabled = true;
  button.classList.add('is-loading');
  var originalText = button.textContent.trim();
  button.textContent = 'Adding...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: variantId, quantity: 1 }),
  })
    .then(function (res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(function () {
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.textContent = 'Added!';

      // Refresh cart-items/cart-footer/cart-item-count and open the drawer via the theme's own cart pipeline
      document.dispatchEvent(new CustomEvent('theme:update:cart'));
      document.dispatchEvent(new CustomEvent('theme:open:cart-drawer'));
    })
    .catch(function () {
      button.classList.remove('is-loading');
      button.textContent = 'Error – retry';
      button.disabled = false;
      setTimeout(function () {
        button.textContent = originalText;
      }, 2500);
    });
}

function initAddonEvents() {
  if (window._kickbackAddonEventsInit) return;
  window._kickbackAddonEventsInit = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-addon-atc]');
    if (!btn) return;

    var productId = btn.getAttribute('data-product-id');
    var variantsJson = btn.getAttribute('data-product-variants');
    var variantId = getSelectedVariantId(productId, variantsJson);

    if (!variantId) {
      variantId = btn.getAttribute('data-variant-id');
    }

    if (variantId) addToCart(variantId, btn);
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-addon-select]');
    if (!sel) return;

    var productId = sel.getAttribute('data-addon-product-id');
    var btn = document.querySelector('[data-addon-atc][data-product-id="' + productId + '"]');
    var variantsJson = btn ? btn.getAttribute('data-product-variants') : null;

    if (variantsJson) updatePriceDisplay(productId, variantsJson);
  });
}

document.addEventListener('shopify:section:load', function () {
  if (typeof window.Splide !== 'undefined') {
    initAddonSplides();
  }
});

waitForSplideAndInit();
